import type { RootState } from 'store/store';

export const FILTERED = '[Filtered]';

const carriesIceServers = (value: unknown): value is { iceServers: unknown } =>
  typeof value === 'object' && value !== null && 'iceServers' in value && value.iceServers != null;

// Keeps the key so an event still shows that servers were sent.
export const redactIceServers = <T>(payload: T): T =>
  carriesIceServers(payload) ? { ...payload, iceServers: FILTERED } : payload;

export const redactActionIceServers = <A extends { type: unknown; payload?: unknown }>(
  action: A
): A => {
  const payload = redactIceServers(action.payload);

  return payload === action.payload ? action : { ...action, payload };
};

// Runs on every reducer call, so it copies only the path it changes.
// Partially preloaded state can lack signaling; a throw here would break every dispatch.
export const redactStateIceServers = (state: RootState | undefined) => {
  if (!state) {
    return null;
  }

  if (!state.application.signaling?.iceServers) {
    return state;
  }

  return {
    ...state,
    application: {
      ...state.application,
      signaling: { ...state.application.signaling, iceServers: FILTERED },
    },
  };
};
